import { Box, Button, Heading, Text, VStack } from 'native-base'
import { useState } from 'react'
import { useDesktopBreakpoint } from '../../../../domain/services/useBreakpoint'
import FormLayout from '../../layouts/FormLayout'
import { useAuthContext } from '../../providers/AuthProvider'
import { useCabanaApi } from '../../providers/CabanaApiProvider'

const AccountCreatedScreen = ({ route }) => {
  const email = route.params?.userEmail
  const { AuthPasswordlessApi } = useCabanaApi()
  const { linkForLogin } = useAuthContext()
  const isDesktop = useDesktopBreakpoint()

  const [isSendingEmail, setIsSendingEmail] = useState(false)

  const doLogin = () => {
    setIsSendingEmail(true)
    if (email) {
      AuthPasswordlessApi.lookupAccount(email)
        .then((response) => {
          setIsSendingEmail(false)
          if (response.data.exists) {
            linkForLogin(email)
          }
        })
        .catch((error) => {
          setIsSendingEmail(false)
          console.debug(error)
        })
    }
  }

  return (
    <FormLayout bg="white">
      {!isDesktop && (
        <Box mt={-4} mx={-6} borderTopWidth={1} borderTopColor="muted.50" />
      )}
      <VStack h="100%" w="100%">
        <Heading fontSize="24px" mb="3" mt="3" color="primary.900">
          Welcome to Cabana
        </Heading>
        <VStack>
          <Text fontSize="18px" fontWeight={600} color="primary.900">
            {email}
          </Text>
          <Text my={6} fontSize="16px" color="primary.900">
            Welcome to Cabana! Click the link in your email to continue.
          </Text>
          <Text mb={6} fontSize="16px" color="primary.900">
            Be sure to check your spam folder if you can’t find the email.{' '}
          </Text>
          <Button
            isLoading={isSendingEmail}
            testID="continue-log-in-button"
            onPress={doLogin}
            variant="link">
            <Text color="secondary.600" underline>
              Resend email
            </Text>
          </Button>
        </VStack>
      </VStack>
    </FormLayout>
  )
}

export default AccountCreatedScreen
